module.exports = __webpack_public_path__ + "static/media/icon.d65f9c0f.png";